import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Config } from 'src/app/app-constant';
import { Location } from '@angular/common';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AccessMatrixDetailsPopupComponent } from '../popups/access-matrix-details-popup/access-matrix-details-popup.component';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';

@Component({
  selector: 'app-grid-layout',
  templateUrl: './grid-layout.component.html',
  styleUrls: ['./grid-layout.component.scss'],
})
export class GridLayoutComponent  implements OnInit {
  @Input() gridData: {
    columnInfo: Array<{label: string,propertyName: string,}>,
    columnData: Array<any>,
    totalCount: number,
    totalNoOfPages: number,
    showCheckBox: boolean,
    showExportBtn: boolean,
    showGraphBtn: boolean,
    showSearchBar:boolean,
    showAddBtn:boolean,
    showDeleteBtn:boolean,
    tabsData:  Array<any>,
    tabsMainData:  Array<any>,
    showPermantDeleteBtn:boolean,
    showRestoreBtn:boolean,
    currentPage: number,
    showTitle: boolean,
    showBreadCrumbs:boolean,
    showAuditLog:boolean,
    showImportBtn: boolean,
    showBackBtn: boolean,
    showRefreshFunctinallity: boolean,
    countTabs:  Array<any>,
  } = {
    columnInfo: [], columnData: [], totalCount: 0, totalNoOfPages: 0, showCheckBox: false, showExportBtn: false, 
    showGraphBtn: false, showSearchBar: false, showAddBtn: true, showDeleteBtn: false, tabsData: [], tabsMainData: [],
    showPermantDeleteBtn: false, showRestoreBtn: false, currentPage: 0, 
    showTitle: false,showBreadCrumbs:false,showAuditLog:false,showImportBtn: false,
    showBackBtn: false, showRefreshFunctinallity: false,countTabs:[]
  };

  @Input() TableName = '';
  @Input() auditLogName = '';
  @Input() paginationUrl: string = '';
  @Input() isChangeDetected: boolean = false;
  @Input() selectedRange: any = 25;
  @Input() searchText:any= null;
  @Input() observationNumber:any = null;
  @Input() selectedStatusTabIndex:any = 0;
  @Input() selectedTypeTabIndex:any = 0;
  @Output() deleteDetailEmmiter = new EventEmitter<any>();
  @Output() editDetailEmmiter = new EventEmitter<any>();
  @Output() searchDataEmitter = new EventEmitter<any>();
  @Output() sortAsendingEmmiter = new EventEmitter<any>();
  @Output() sortDesendingEmmiter = new EventEmitter<any>();
  @Output() graphEmmiter = new EventEmitter<any>();
  @Output() exportEmmiter = new EventEmitter<any>();
  @Output() importEmmiter = new EventEmitter<any>();
  @Output() emmitPagination = new EventEmitter<any>();
  @Output() detailsEmmiter = new EventEmitter<any>();
  @Output() detailsWithColumn = new EventEmitter<any>();
  @Output() addRecordEmmiter = new EventEmitter<any>();
  @Output() applyFilterEmmiter = new EventEmitter<any>();
  @Output() deleteMultipleRecordsEmmiter = new EventEmitter<any>();
  @Output() restoreRecordsEmmiter = new EventEmitter<any>();
  @Output() paginationDataEmmiter = new EventEmitter<any>();
  @Output() showNumberOfRecordsEmmiter = new EventEmitter<any>();
  @Output() refreshDataEmmiter = new EventEmitter<any>();
  @Output() typeTabEmmiter = new EventEmitter<any>();
  @Output() statusTabEmmiter = new EventEmitter<any>();
  @Output() importFileEmmiter = new EventEmitter<any>();
  @Output() filterEmmiter = new EventEmitter<any>();
  @Output() backbtnEmmiter = new EventEmitter<any>();
  selectedDate: any = moment();
  renderData: Array<any> = [];
  selectAllCheckbox:boolean=false;
  mulipleSelect:any = [];
  deltetedDatacount: number = 0;
  currentPage: number = 1;
  page:any=0;
  loggedInUserRole: any;
  @ViewChild('allSelected') allSelected: any;
  sidebarModule:any=[];
  isAddFlag : boolean = true;
  isEditFlag : boolean =true;
  isPerDeleteFlag : boolean = true;
  showDelete: boolean = false;
  activeTab: any;
  private subscription!: Subscription;
  collapseSidebar: boolean = false;
  buttonColorName: any;
  subModuleButtonColor: any;
  showingCount:any=1;
  showingOfCount:any=0;
  previousPageTotalCount:any=0;
  loggedInUserCompanyID:any;
  employeeIdOfMD:any = null;
  constructor(private httpService: HttpService, private config: Config, 
    private datePipe: DatePipe, public fb: FormBuilder, 
    public router: Router,private location: Location,
    private sharedService: SharedService,public dialog: MatDialog,private encryptionService:EncryptionService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if(this.employeeIdOfMD == null){
      this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
      if(this.router.url.includes('employeemaster')){
        this.getCompanyDataByCompID();
      }
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.collapseSidebar=this.sharedService.getBooleanValue();
    console.log(this.gridData.columnData)
    this.selectAllCheckbox = false;
    this.mulipleSelect=[];
    this.renderColumnData();
    this.sidebarModule=JSON.parse(localStorage.getItem('pemissionModules')!);
    for(let i = 0; i < this.sidebarModule?.length; i++){
      if(this.sidebarModule[i]?.routerName == this.router.url){
        this.isAddFlag = this.sidebarModule[i]?.isAdd;
        this.isEditFlag = this.sidebarModule[i]?.isEdit;
        this.isPerDeleteFlag = this.sidebarModule[i]?.isPerDeleted;
      }
    }
  }
  ionViewWillEnter() {
  }
  private expandAndCollapseSidebar() {
    // this.collapseSidebar =! this.collapseSidebar;
  }
  ngOnInit(){
    // this.loggedInUserRole = localStorage.getItem('loggedInUserRole');
    // this.loggedInUserRole = this.encyptDecryptData.decryptData(this.loggedInUserRole);
  }
  onSelectCount(data:any){
    this.showNumberOfRecordsEmmiter.emit(data?.value);
  }
  private renderColumnData(){
    this.renderData = [];
    for(let i = 0; i < this.gridData.columnData.length; i++){
      var output = Object.entries(this.gridData.columnData[i]).map(([key, value]) => ({key,value}));
      this.renderData.push(output);
      this.renderData[i].checkboxCheck=false;
      if(this.router.url.includes('employeemaster')){
        if(this.gridData.columnData[i].linkName == this.employeeIdOfMD){
          this.renderData[i].isEmployeeMD = true;
        }else{
          this.renderData[i].isEmployeeMD = false;
        }
      }else{
        this.renderData[i].isEmployeeMD = false;
      }
    }
    this.currentPage = this.gridData.currentPage + 1 | 0;
    // if(this.selectedRange )
    if(this.previousPageTotalCount != this.gridData.totalCount){
      this.showingCount=1;
      this.showingOfCount=0;
    }
    if(this.gridData.currentPage == 0){
      this.showingCount=1;
      this.showingOfCount=0;
    }
    if(this.gridData.totalCount >= this.renderData.length){
      if(this.selectedRange == this.renderData.length){
        this.showingOfCount = (this.gridData.currentPage + 1) * this.selectedRange;
      } else{
        this.showingOfCount = this.showingOfCount + this.renderData.length
      }
      this.previousPageTotalCount = this.gridData.totalCount;
    }
    if(this.gridData.currentPage == 0){
      this.showingCount = 1;
    }else{
      this.showingCount = (this.selectedRange * this.gridData.currentPage)+1 
    }
  }
  selectALLRecords(event:any){
    if (event.checked) {
      this.showDelete = true;
      for(let i=0; i<this.renderData.length;i++){
        this.renderData[i].checkboxCheck=true;
        this.selectAllCheckbox=true;
        this.mulipleSelect.push(this.renderData[i])
      }
    }else{
      this.showDelete = false;
      for(let i=0; i<this.renderData.length;i++){
        this.renderData[i].checkboxCheck=false;
        this.mulipleSelect = [];
        this.selectAllCheckbox=false;
      }
    }
  }
  selectSingleRecord(event:any,data:any,i:number){
    console.log(data)
    if(event.checked) {
      this.showDelete = true;
      this.renderData[i].checkboxCheck=true;
      this.deltetedDatacount++;
      this.mulipleSelect.push(data);
    }else {
      this.showDelete = false;
      this.renderData[i].checkboxCheck=false;
      this.deltetedDatacount--;
      this.mulipleSelect.forEach((ele:any,ind:any)=>{
        if(ele.checkboxCheck == false){
          this.mulipleSelect.splice(ind,1);
        }
      })
      if(this.deltetedDatacount==0){
        this.mulipleSelect=[];
      }
      this.selectAllCheckbox=false;
    }
  }
  deleteMultipleRecords(){
    this.deleteMultipleRecordsEmmiter.emit(this.mulipleSelect);
  }
  restoreData(){
    this.restoreRecordsEmmiter.emit(this.mulipleSelect);
  }
  public showSpecificButtons(data: any,compareValue: string): boolean{
    return (data.value as string).includes(compareValue);
  }
  onSearch(){
    this.searchDataEmitter.emit(this.searchText);
  }
  exportReport(){
    this.exportEmmiter.emit(this.mulipleSelect);
  }
  importReport(){
    this.importFileEmmiter.emit();
  }
  garaphReport(){
    this.graphEmmiter.emit();
  }
  addRecord(){
    this.addRecordEmmiter.emit();
  }
  editDetail(data:any){
    this.editDetailEmmiter.emit(data);
  }
  deleteDetail(data:any){
    this.deleteDetailEmmiter.emit(data);
  }
  onSortAssending(data:any){
    this.sortAsendingEmmiter.emit(data);
  }
  onSortDesending(data:any){
    this.sortDesendingEmmiter.emit(data);
  }
  applyFilter(){
    this.applyFilterEmmiter.emit();
  }
  previousPage(){
    if(this.currentPage < 2){
      return;
    }else{
      this.currentPage--;
      this.page--;
      this.paginationNextOrPrevious();
    }
  }
  nextPage(){
    if(this.currentPage >= this.gridData.totalNoOfPages){
      return;
    }
    if(this.currentPage==1){
      this.page=1;
    }else{
      this.page++;
    }
    this.currentPage++;
    this.paginationNextOrPrevious();
  }
  paginationNextOrPrevious(){
    localStorage.setItem('currentPageNumber', this.page)
    this.paginationDataEmmiter.emit(this.page);
  }
  showDetailsWithColumn(data:any, colName:any){
    let details = {
      data: data,
      colName: colName
    }
    this.detailsWithColumn.emit(details)
  }
  showDetails(data:any){
    this.detailsEmmiter.emit(data);
  }
  onClickConfig(){
    this.router.navigate(['/home/configrations/configuration-dashboard']);
  }
  onClickConfigName(){
  }
  onClickDelete(){
    this.deleteMultipleRecordsEmmiter.emit(this.mulipleSelect);
  }

  refreshData(){
    this.refreshDataEmmiter.emit();
  }
  backBtn(){
    this.backbtnEmmiter.emit();
    // this.location.back()
  }
  tabStatusChanged(event:any){
    this.statusTabEmmiter.emit(event);
  }
  tabTypeChanged(event:any){
    this.typeTabEmmiter.emit(event);
  }
  filterDetail(data:any){
    this.filterEmmiter.emit(data);
  }
  showDetailsOfAccessMatrix(data:any,popupName:any,listMainData:any){
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '50%';
    dialogConfig.data = {
      data: data,
      popupName: popupName,
      listMainData: listMainData,
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    this.dialog.open(AccessMatrixDetailsPopupComponent, dialogConfig);
  }
  getCompanyDataByCompID() {
    this.httpService.callGetService(this.config.getCompanyDataByCompID + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.employeeIdOfMD = data?.data?.employeeIdOfMD;
    })
  }
}
